import React, {createContext, useContext, useEffect, useRef, useState} from "react";
import {initialToggle} from "./components/panels/config.jsx";
import {useQuery} from "@tanstack/react-query";
import bosService from "../../../../services/web/bos-service.js";
import {format, subMinutes} from "date-fns";

const EdgeBuilderContext = createContext(null);

export const useEdgeBuilder = () => useContext(EdgeBuilderContext);

const initialFilterPassage = {
    startDate: format(subMinutes(new Date(), 60), "yyyy-MM-dd HH:MM"),
    endDate: format(new Date(), "yyyy-MM-dd HH:MM"),
    threshold: "00:30",
    minMatches: 2,
    maxPassages: 100,
}

export function EdgeBuilderProvider({children, id}) {
    const [newEdge, setNewEdge] = useState(null);
    const [panelOpened, setPanelOpened] = useState(null)
    const [viewMode, setViewMode] = useState("flow")
    const [selectedNode, setSelectedNode] = useState(null)
    const [filterPassage, setFilterPassage] = useState(initialFilterPassage)
    const [toggleItemsNode, setToggleItemsNode] = useState(initialToggle)
    const [images, setImages] = useState([])
    const [deletedAttach, setDeletedAttach] = useState([])

    const [isLoading, setIsLoading] = useState(false);
    const [showCancelRequestBtn, setShowCancelRequestBtn] = useState(false);

    const { data: boName} = useQuery({
        queryFn: () =>  bosService.getBoName().then((data) => {
            return data
        }),
        queryKey: ['boName']
    });

    useEffect(() => {
        const configStorage = localStorage.getItem("config_association")
        if (configStorage) {
            setToggleItemsNode(JSON.parse(configStorage))
        }
    }, []);

    const value = {
        newEdge,
        setNewEdge,
        reset: () => setNewEdge(null),
        panelOpened, setPanelOpened,
        viewMode, setViewMode,
        selectedNode, setSelectedNode,
        filterPassage, setFilterPassage,
        toggleItemsNode, setToggleItemsNode,
        boName,
        isLoading, setIsLoading,
        showCancelRequestBtn, setShowCancelRequestBtn, id,
        images, setImages, deletedAttach, setDeletedAttach
    }

    return (
        <EdgeBuilderContext.Provider value={value}>
            {children}
        </EdgeBuilderContext.Provider>
    );
}
